export const BuyBackdrop = () => (
  <div className="buy-backdrop" aria-hidden="true" data-testid="buy-space-background">
    <img className="buy-backdrop__bull" src="/assets/artwork/buy/bull.webp" alt="" width="404" height="443" decoding="async" />
    <img className="buy-backdrop__city" src="/assets/artwork/buy/city.webp" alt="" width="335" height="437" decoding="async" />
    <div className="buy-backdrop__grid" />
    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => <i key={i} className="buy-backdrop__star" style={{ "--star": i }} />)}
  </div>
);